import React, { useEffect, useState } from "react";
import { Button, Checkbox, DatePicker, Divider, Form, Input, InputNumber, Select } from "antd";
import { InfoClient } from "../../../../components/Form/project/infoClient/InfoClient";
import { Calendar, Clock, Coin, Comments, User } from "../../../../components/icons";
import { structureFormProject } from "../../../../helpers/projectHelper";
import { MessageAnt } from "../../../../redux/slices/ui/uiAction";
import { imagesgeneral } from "../../../../assets/type_assets";
import { MessageType } from "../../../../types/messageType";

const dateFormat = "YYYY/MM/DD";

const initForm = {
    name: "",
    clickupSpace: "",
    description: "",
    startedDate: "",
    weeks: "",
    existLimitDateProject: "",
    deadLine: "",
    isOwn: false,
    clientInformation: [],
    planning: 0,
    development: {
        total: 0,
    },
    assetMoneyMX: 0,
    assetMoneyDLL: 0,
    providerMoneyMX: 0,
    providerMoneyDLL: 0,
};
export const FormNewProject = ({ projects = [], onFinish = () => { } }) => {
    const [form] = Form.useForm();

    const [loading, setLoading] = useState(false);
    const [checkLimitDate, setCheckLimitDate] = useState(false);

    const onValuesChange = (changedValues, allValues) => {
        const key = Object.keys(changedValues)[0];
        const value = Object.values(changedValues)[0];

        if (key === "clickupSpace") {
            form.setFieldsValue({ name: value });
        }
    };

    const onChangeCheckLimitDate = () => {
        setCheckLimitDate(!checkLimitDate);
    };

    const finishForm = (values) => {
        setLoading(true);
        const { structureForm, status, msg } = structureFormProject(values, { clickupid: projects });
        if (status > 0) {
            setLoading(false);
            MessageAnt(MessageType.error, msg);
            return;
        }
        onFinish(structureForm);
        setLoading(false);
    };
    const resetForm = () => {
        form.setFieldsValue(initForm);
    };


    useEffect(() => {
        form.setFieldsValue(initForm);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <Form
                form={form}
                onValuesChange={onValuesChange}
                onFinish={finishForm}
                layout="vertical"
                name="dynamic_form_nest_item"
                autoComplete="off"
                className="w-full text-xs"
            >
                <Divider orientation="left" orientationMargin={0}>
                    <div className="flex items-center justify-center gap-2">
                        <Comments />
                        <p>Información del proyecto</p>
                    </div>
                </Divider>
                <div className="flex gap-4">
                    <Form.Item className="w-full text-xs" name="name" label="Nombre">
                        <Input disabled={true} />
                    </Form.Item>
                    <Form.Item
                        className="w-full text-xs"
                        name="clickupSpace"
                        label="Clickup proyecto"
                        rules={[
                            {
                                required: true,
                                message: "Por favor selecciona el projecto!",
                            },
                        ]}
                    >
                        <Select placeholder="seleccionar el projecto de clickup" showSearch>
                            {projects.map((project) => (
                                <Select.Option key={`${project.id}-rol`} value={project.name}>
                                    {project.name}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                </div>
                <Form.Item className="w-full text-xs" name="description" label="Descripción del proyecto">
                    <Input.TextArea
                        placeholder="Información"
                        autoSize={{
                            minRows: 5,
                            maxRows: 5,
                        }}
                    />
                </Form.Item>
                <Form.Item className="w-full text-xs" name="isOwn" valuePropName="checked">
                    <Checkbox className="flex items-start lg:mb-6 lg:flex-row-reverse lg:justify-end">
                        <p className=" text-xs font-semibold">Es interno?</p>
                    </Checkbox>
                </Form.Item>
                <Divider orientation="left" orientationMargin={0} className="mt-8">
                    <div className="flex items-center justify-center gap-2">
                        <Calendar />
                        <p>Fechas</p>
                    </div>
                </Divider>
                <div className="flex flex-wrap gap-x-4 lg:flex-nowrap">
                    <div className="flex gap-4 w-full lg:w-1/2">
                        <div className="flex flex-col w-full">
                            <p className="mb-2 text-xs font-semibold">* Fecha estimada de inicio</p>
                            <Form.Item
                                className="w-full text-xs"
                                name="startedDate"
                                rules={[
                                    {
                                        required: true,
                                        message: "Escribe la fecha de inicio",
                                    },
                                ]}
                            >
                                <DatePicker className="w-full" format={dateFormat} />
                            </Form.Item>
                        </div>
                        <div className="flex flex-col w-full">
                            <p className="mb-2 text-xs font-semibold">* Semanas de desarrollo</p>
                            <Form.Item
                                className="w-full text-xs"
                                name="weeks"
                                rules={[
                                    {
                                        type: "number",
                                        min: 1,
                                        message: "Escribe las semanas de desarrollo",
                                    },
                                    {
                                        required: true,
                                        message: "Necesita mayor a cero",
                                    },
                                ]}
                            >
                                <InputNumber className="w-full" size="medium" min={0} />
                            </Form.Item>
                        </div>
                    </div>
                    <div className="flex flex-col gap-4 items-start w-full lg:w-1/2 lg:flex-row">
                        <Form.Item className="w-full text-xs" name="existLimitDateProject" valuePropName="checked">
                            <Checkbox onChange={onChangeCheckLimitDate} className="flex items-start lg:mb-6 lg:flex-row-reverse lg:justify-end">
                                <p className=" text-xs font-semibold">Fecha límite de entrega</p>
                            </Checkbox>
                        </Form.Item>
                        {checkLimitDate && (
                            <div className="flex flex-col w-full">
                                <p className="mb-2 text-xs font-semibold">Fecha límite de entrega</p>
                                <Form.Item
                                    className="w-1/2 lg:w-full pr-2 text-xs"
                                    name="deadLine"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Escribe la fecha límite",
                                        },
                                    ]}
                                >
                                    <DatePicker className="w-full" format={dateFormat} />
                                </Form.Item>
                            </div>
                        )}
                    </div>
                </div>
                <Divider orientation="left" orientationMargin={0} className="mt-8">
                    <div className="flex items-center justify-center gap-2">
                        <Clock />
                        <p>Horas presupuestadas</p>
                    </div>
                </Divider>
                <div className="flex gap-4">
                    <div className=" flex flex-col w-full">
                        <p className="mb-2 text-xs font-semibold">* Planeación</p>
                        <Form.Item
                            className="w-full text-xs"
                            name="planning"
                            rules={[
                                {
                                    type: "number",
                                    min: 1,
                                    message: "Escribe las horas de planeacion",
                                },
                                {
                                    required: true,
                                    message: "Necesita mayor a cero",
                                },
                            ]}
                        >
                            <InputNumber className="w-full" size="medium" min={0} />
                        </Form.Item>
                    </div>
                    <div className="flex flex-col w-full">
                        <p className="mb-2 text-xs font-semibold">* Horas de desarrollo</p>
                        <Form.Item
                            className="w-full text-xs"
                            name={["development", "total"]}
                            rules={[
                                {
                                    type: "number",
                                    min: 1,
                                    message: "Escribe las horas de planeacion",
                                },
                                {
                                    required: true,
                                    message: "Necesita mayor a cero",
                                },
                            ]}
                        >
                            <InputNumber className="w-full" size="medium" min={0} />
                        </Form.Item>
                    </div>
                </div>

                <Divider orientation="left" orientationMargin={0} className="mt-8">
                    <div className="flex items-center justify-center gap-2">
                        <User />
                        <p>Información del Cliente (Opcional)</p>
                    </div>
                </Divider>
                <InfoClient />
                <Divider orientation="left" orientationMargin={0} className="mt-8">
                    <div className="flex items-center justify-center gap-2">
                        <Coin />
                        <p>Equivalencia de horas en Mx y Dll</p>
                    </div>
                </Divider>
                <div className="grid grid-cols-1 lg:grid-cols-2 lg:gap-4">
                    <div>
                        <span className="block text-sm mb-1 font-semibold">Assets</span>
                        <div className="grid grid-cols-2 gap-4">
                            <div className="flex flex-col w-full">
                                <div className="flex items-center gap-1 mb-1 text-[10px]">
                                    *
                                    <img src={imagesgeneral.mexicoFlag} alt="" className="w-4 h-4 inline-block" />
                                    <p>Hrs de assets en MX</p>
                                </div>
                                <Form.Item
                                    className="w-full"
                                    name={["assetMoneyMX"]}
                                    rules={[
                                        {
                                            type: "number",
                                            min: 1,
                                            message: "Escribe la equivalencia",
                                        },
                                        {
                                            required: true,
                                            message: "Necesita mayor a cero",
                                        },
                                    ]}
                                >
                                    <InputNumber className="w-full" size="medium" min={0} />
                                </Form.Item>
                            </div>
                            <div className="flex flex-col w-full">
                                <div className="flex items-center gap-1 mb-1 text-[10px]">
                                    *
                                    <img src={imagesgeneral.usaFlag} alt="" className="w-4 h-4 inline-block" />
                                    <p>Hrs de assets en DLL</p>
                                </div>
                                <Form.Item
                                    className="w-full"
                                    name={["assetMoneyDLL"]}
                                    rules={[
                                        {
                                            type: "number",
                                            min: 1,
                                            message: "Escribe la equivalencia",
                                        },
                                        {
                                            required: true,
                                            message: "Necesita mayor a cero",
                                        },
                                    ]}
                                >
                                    <InputNumber className="w-full" size="medium" min={0} />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div>
                        <span className="block text-sm mb-1 font-semibold">Proveedores</span>
                        <div className="grid grid-cols-2 gap-4">
                            <div className="flex flex-col w-full">
                                <div className="flex items-center gap-1 mb-1 text-[10px]">
                                    *
                                    <img src={imagesgeneral.mexicoFlag} alt="" className="w-4 h-4 inline" />
                                    <p>Hrs de proveedores en MX</p>
                                </div>
                                <Form.Item
                                    className="w-full"
                                    name={["providerMoneyMX"]}
                                    rules={[
                                        {
                                            type: "number",
                                            min: 1,
                                            message: "Escribe la equivalencia",
                                        },
                                        {
                                            required: true,
                                            message: "Necesita mayor a cero",
                                        },
                                    ]}
                                >
                                    <InputNumber className="w-full" size="medium" min={0} />
                                </Form.Item>
                            </div>
                            <div className="flex flex-col w-full">
                                <div className="flex items-center gap-1 mb-1 text-[10px]">
                                    *
                                    <img src={imagesgeneral.usaFlag} alt="" className="w-4 h-4 inline" />
                                    <p className="inline-block">Hrs de proveedores en DLL</p>
                                </div>
                                <Form.Item
                                    className="w-full"
                                    name={["providerMoneyDLL"]}
                                    rules={[
                                        {
                                            type: "number",
                                            min: 1,
                                            message: "Escribe la equivalencia",
                                        },
                                        {
                                            required: true,
                                            message: "Necesita mayor a cero",
                                        },
                                    ]}
                                >
                                    <InputNumber className="w-full" size="medium" min={0} />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex gap-4 items-center justify-end -mb-4 mt-4">
                    <Form.Item>
                        <Button className="w-24 h-8" type="default" onClick={resetForm}>
                            Reset
                        </Button>
                    </Form.Item>
                    <Form.Item>
                        <Button className="w-24 h-8" type="primary" htmlType="submit" loading={loading}>
                            Guardar
                        </Button>
                    </Form.Item>
                </div>
            </Form>
        </>
    );
};
